<template>
    <b-modal v-model="modalShow" ref="modal-cancel" size="sm" title="Dividir Leads">
        <b-form novalidate="novalidate" autocomplete="off">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group is-filled">
                        <label for="salesman_id" class="bmd-label-floating">Origem</label>
                        <model-list-select
                            class="form-control"
                            placeholder="Leads livres"
                            option-value="id"
                            option-text="name"
                            v-model="form.salesman_id"
                            v-bind:list="salesmans"></model-list-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group bmd-form-group is-filled"
                         v-bind:class="{'has-danger' : validation.team_id != ''}">
                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                        <model-list-select 
                            class="form-control"
                            :list="teams"
                            placeholder="Todas" 
                            option-value="id"
                            option-text="name"
                            v-model="form.team_id"
                            :state="validation.team_id == ''">
                        </model-list-select>
                        <label v-if="validation.team_id != ''" id="team_id-error" class="error" for="team_id">{{ validation.team_id }}</label>
                    </div>
                </div>
            </div>
        </b-form>
        <div slot="modal-footer">
            <button @click="onSubmitCancel" class="btn btn-rose btn-sm">
                <span class="btn-label">
                    <i class="material-icons">done</i>
                </span>
                Salvar
            </button>
            <b-button @click="goBack" size="sm">
                <span class="btn-label">
                    <i class="material-icons">{{ 'keyboard_arrow_left' }}</i>
                </span>
                {{ 'Voltar' }}
            </b-button> 
        </div>
    </b-modal>
</template>

<script>
    import UserService from '@/services/modules/users.service';

    export default {
        data() {
            return {
                form: {
                    salesman_id: '',
                    team_id: '',
                },
                modalShow: true,
                salesmans: [],
                validation: {
                    team_id: ''
                }
            };
        },
        mounted() {
            var self = this;

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });

            if (self.teams.length == 0) {
                self.getTeamsData();
            } else {
                self.getSalesman();
            }
        },
        computed: {
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            }
        },
        methods: {
            async getSalesman() {
                var self = this;
                self.$root.$emit("onLoading");

                var params = "branch_id=" + self.$store.state.auth.user.branch_id + "&profile_id=4";
                const response = UserService.all(params);

                response.then(function (_users) {
                    var salesmans = _users;
                    salesmans.push({
                        id: '',
                        name: 'Leads livres'
                    });
                    self.salesmans = salesmans;
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$root.$emit("onLoading");
                    self.$router.push({'name': 'leads.supervise.index'});
                });
            },
            async getTeamsData() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getSalesman();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getSalesman();
                });
            },
            goBack() {
                var self = this;
                self.$router.push({'name': 'leads.supervise.index'});
            },
            onSubmitCancel(_ev) {
                var self = this;
                var valid = true;

                _ev.preventDefault();

                self.validation = {
                    team_id: ''
                };

                if (valid) {
                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch('lead/share', self.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Leads divididas com sucesso!");
                        self.$root.$emit("loadLeads");
                        self.goBack();
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        self.$notify.error("Não foi possível dividir as leads, tente novamente!");
                    });
                }
            }
        }
    }
</script>
